import PropTypes from "prop-types";
import styles from "./UplinesList.module.css";
import UplineItem from "../UplineItem";

/**
 * Interactive component. List of uplines with a header.
 */
export function UplinesList({ uplines }) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>Upline</div>
          <div className={styles.headerItem}>Name</div>
          <div className={styles.headerItem}>IBO #</div>
          <div className={styles.headerItem}>Dreamstream ID</div>
        </div>

        <div className={styles.uplinesContainer}>
          {uplines.map((upline, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <UplineItem
                uplineInfo={{
                  upline: upline.upline,
                  name: upline.name,
                  iboNum: upline.iboNum,
                  dsId: upline.dsId,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

UplinesList.propTypes = {
  uplines: PropTypes.arrayOf(PropTypes.object),
};
